import { CustomPhoto } from './customPhoto.mdl';
import { PhotoModel } from './photo.mdl'

export class PhotoListModel {
  public category: string;
  public numberOfPhotos: number;
  public photoList: PhotoModel[];
  public customPhotoList?: CustomPhoto[];
}


// WEBPACK FOOTER //
// ./src/common/models/photoList.mdl.ts